import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { UsersState } from './types';
import {
  disableUserRequest,
  enableUserRequest,
  getAllUsersItemsRequest,
} from './userAPI';

interface GetAllUsersParams {
  page: number;
  limit: number;
  isActive: boolean;
  name: string;
  roles: string;
  email: string;
}

export const getAllUsers = createAsyncThunk(
  'wavelight/get-all-users-items',
  async ({ page, limit, isActive, name, roles, email }: GetAllUsersParams) => {
    return await getAllUsersItemsRequest(
      page,
      limit,
      isActive,
      name,
      roles,
      email,
    );
  },
);

export const disableItem = createAsyncThunk(
  'wavelight/disable-user',
  async (id: string) => {
    await disableUserRequest(id);
    return id;
  },
);

export const enableItem = createAsyncThunk(
  'wavelight/enable-user',
  async (id: string) => {
    await enableUserRequest(id);
    return id;
  },
);

const initialState: UsersState = {
  isLoading: false,
  error: null,
  items: null,
  item: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message ?? null;
      })
      .addCase(disableItem.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(disableItem.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(disableItem.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message ?? null;
      })
      .addCase(enableItem.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(enableItem.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(enableItem.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message ?? null;
      });
  },
});

export const { setLoading } = userSlice.actions;

export default userSlice.reducer;
